<template>
  <v-expansion-panel
    class="default-panel default-content--text sidebar-viewer-panel"
    v-bind="$attrs"
  >
    <v-expansion-panel-title>
      {{ label }}
      <slot name="label" />
    </v-expansion-panel-title>
    <v-expansion-panel-text class="sidebar-viewer-panel-body">
      <slot />
    </v-expansion-panel-text>
  </v-expansion-panel>
</template>

<script>
export default {
  name: 'BaseSidebarViewerPanel',

  inheritAttrs: false,

  props: {
    label: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.sidebar-viewer-panel-body {
  overflow: visible;
}

/* V2 expansion-panel-header: 48px min-height, 16px 24px padding */
.sidebar-viewer-panel :deep(.v-expansion-panel-title) {
  min-height: 48px;
  padding: 16px 24px;
  font-size: 0.9375rem;
  font-weight: 500;
  line-height: 1.375rem;
}

.sidebar-viewer-panel-body :deep(.v-list) {
  padding-inline: 12px;
  overflow: visible;
}

.sidebar-viewer-panel-body :deep(.v-switch .v-selection-control) {
  margin-inline-start: 0;
  min-height: auto;
}
</style>
